import { useCallback } from 'react';
import { useOverlappingFeaturesState } from 'state/useOverlappingFeaturesState';
import { usePoisState } from 'state/usePoisState';
import { useMapDrawerEntityForPoiState } from 'state/useMapDrawerEntityForPoiState';

/**
 * Clears overlapping stack, selected POIs, and map-drawer POI entity so router-driven
 * entity UI can take over.
 */
export const useClearMapSelectionsForRouterEntity = (): (() => void) => {
  const { clearOverlappingFeatures } = useOverlappingFeaturesState();
  const { clearSelectedPois } = usePoisState();
  const { setMapDrawerEntityForPoi } = useMapDrawerEntityForPoiState();

  return useCallback(() => {
    clearOverlappingFeatures();
    clearSelectedPois();
    setMapDrawerEntityForPoi(null);
  }, [clearOverlappingFeatures, clearSelectedPois, setMapDrawerEntityForPoi]);
};
